import { FunctionComponent } from 'react'
import { useIsAdmin } from '../hooks/authHooks'

export const AdminOnlyView: FunctionComponent = ({ children }) => {
  const isAdmin = useIsAdmin()

  if (!isAdmin) return null

  return <>{children}</>
}
